import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import {
  Container,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DescriptionIcon from "@mui/icons-material/Description";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import EmailIcon from "@mui/icons-material/Email";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import axios from "axios"; // Import axios
import { useLocation, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import { jsPDF } from "jspdf"; // Import jsPDF

const Subscription = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { opportunityTitle, selectedPlans } = location.state || {};
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    location: "",
  });
  const [idProofFile, setIdProofFile] = useState(null); // State for ID Proof File
  const [idProofUrl, setIdProofUrl] = useState(null); // State for ID Proof Image Preview

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        console.log("User ID:", user.id); // Log the user_id to the console

        //const response = await axios.get(`http://localhost:5000/api/users/${user.id}`);
        const response = await axios.get(`${API_BASE_URL}/users/${user.id}`);

        console.log("User Data Response:", response.data); // Log the response data

        setUserData({
          name: response.data.name,
          email: response.data.email,
          location: response.data.city,
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (user && user.id) {
      fetchUserData();
    }
  }, [user]);

  const handleFileChange = (e, setFile, setPreviewUrl) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      setPreviewUrl(URL.createObjectURL(file)); // Create object URL for preview
    }
  };

  const handlePayment = async (e) => {
    e.preventDefault();

    if (!user) {
      alert("User is not logged in!");
      return;
    }

    const user_id = user.id;

    // Prepare the data to send to the backend
    const formElements = e.target.elements;
    const name = formElements.name.value;
    const location = formElements.location.value;
    const imageUrl = formElements.image_url.value;
    const email = formElements.email.value;

    const subscriptionData = {
      user_id,
      name,
      email,
      opportunity: opportunityTitle || "",
      type_of_subscription: selectedPlans[0]?.plan || "",
      description: selectedPlans[0]?.description || "",
      price: selectedPlans[0]?.price || "",
      location,
      image_url: imageUrl,
      id_proof_url: idProofFile,
    };

    try {
      // Step 1: Store subscription details in the database
      const subscriptionResponse = await axios.post(
        // "http://localhost:5000/api/subscriptions",
        `${API_BASE_URL}/subscriptions`,
        subscriptionData
      );
      console.log("Subscription saved successfully:", subscriptionResponse.data);

      // Step 2: Create an order with Razorpay after storing subscription data
      const orderResponse = await axios.post(
        // "http://localhost:5000/api/payments/create-order",
        `${API_BASE_URL}/payments/create-order`,
        {
          amount: selectedPlans[0]?.price * 100, // price in paise
          currency: "INR",
        }
      );

      const { orderId, currency, amount } = orderResponse.data;

      const options = {
        key: "rzp_test_2eOTYJ5qhLc4UV", // Your Razorpay test key here
        amount,
        currency,
        name: "City Zoom",
        description: `Subscription for ${name}`,
        order_id: orderId,

        handler: async function (response) {
          // Step 3: Send payment details to backend
          try {
            const paymentData = {
              user_id,
              name,
              amount: selectedPlans[0]?.price,
              payment_method: "razorpay",
              status: "success",
              transaction_id: response.razorpay_payment_id,
              opportunity: opportunityTitle || "",
              start_date: new Date(),
              end_date: new Date(),
            };

            // Store payment details in the database
            //await axios.post("http://localhost:5000/api/payments", paymentData);
            await axios.post(`${API_BASE_URL}/payments`, paymentData);
            alert("Payment Successful!");

            // Step 4: Generate the receipt as a PDF and download it
            const receiptData = {
              ...paymentData,
              opportunityTitle: opportunityTitle,
              receiptId: response.razorpay_payment_id,
            };

            console.log("Receipt:", receiptData);

            // Create PDF using jsPDF
            const doc = new jsPDF();
            doc.setFont("helvetica", "normal");

            doc.text("Receipt", 20, 20);
            doc.text(`Receipt ID: ${receiptData.receiptId}`, 20, 30);
            doc.text(`User ID: ${receiptData.user_id}`, 20, 40);
            doc.text(`Name: ${receiptData.name}`, 20, 50);
            doc.text(`Amount: ₹ ${receiptData.amount}`, 20, 60);
            doc.text(`Payment Method: ${receiptData.payment_method}`, 20, 70);
            doc.text(`Status: ${receiptData.status}`, 20, 80);
            doc.text(`Transaction ID: ${receiptData.transaction_id}`, 20, 90);
            doc.text(`Opportunity: ${receiptData.opportunity}`, 20, 100);
            doc.text(`Start Date: ${receiptData.start_date}`, 20, 110);
            doc.text(`End Date: ${receiptData.end_date}`, 20, 120);

            // Save the generated PDF as a file
            doc.save(`receipt_${receiptData.receiptId}.pdf`);

            // Navigate to the relevant opportunity page based on the selected opportunity
            if (opportunityTitle === "Jobs") {
              navigate("/post-job");
            } else if (opportunityTitle === "Services") {
              navigate("/post-service");
            } else if (opportunityTitle === "Offers") {
              navigate("/post-offer");
            } else if (opportunityTitle === "Events") {
              navigate("/post-event");
            } else if (opportunityTitle === "Sponsored Ad") {
              navigate("/post-ad");
            } else if (opportunityTitle === "Classifieds") {
              navigate("/post-classified");
            }
          } catch (error) {
            console.error("Error storing payment details:", error);
          }
        },
        prefill: {
          name: name,
          email: email,
          contact: "0000000000",
        },
        notes: {
          address: location,
        },
      };

      // Open Razorpay's checkout modal
      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Error initiating payment:", error);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5, mb: 4 }}>
      <Card sx={{ p: 4, boxShadow: 4, borderRadius: 2 }}>
        <CardContent>
          <Typography
            variant="h5"
            color="#42326e"
            fontWeight="bold"
            textAlign="center"
            mb={3}
          >
            Subscription
          </Typography>
          <form onSubmit={handlePayment}>
            {/* Name Field */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <PersonIcon sx={{ flexShrink: 0, color: "#42326e" }} />
              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                name="name"
                value={userData.name}
                disabled
              />
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <EmailIcon sx={{ flexShrink: 0, color: "#42326e" }} />
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                type="email"
                name="email"
                value={userData.email}
                disabled
              />
            </Box>

            {/* Opportunity Title */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <HandshakeIcon sx={{ flexShrink: 0, color: "#42326e" }} />
              <TextField
                fullWidth
                label="Opportunity"
                variant="outlined"
                value={opportunityTitle || ""}
                disabled
              />
            </Box>

            {/* Loop through selected plans and display their information */}
            {selectedPlans &&
              selectedPlans.map((plan, index) => (
                <div key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <ScheduleSendIcon
                      sx={{ flexShrink: 0, color: "#42326e" }}
                    />
                    <TextField
                      fullWidth
                      label="Type Of Subscription"
                      variant="outlined"
                      value={plan.plan}
                      disabled
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <DescriptionIcon
                      sx={{ flexShrink: 0, color: "#42326e" }}
                    />
                    <TextField
                      fullWidth
                      label="Description"
                      variant="outlined"
                      value={plan.description}
                      disabled
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <CurrencyRupeeIcon
                      sx={{ flexShrink: 0, color: "#42326e" }}
                    />
                    <TextField
                      fullWidth
                      label="Price (₹)"
                      variant="outlined"
                      value={plan.price}
                      disabled
                    />
                  </Box>
                </div>
              ))}

            {/* Location Field */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <LocationOnIcon sx={{ flexShrink: 0, color: "#42326e" }} />
              <TextField
                fullWidth
                label="Location"
                variant="outlined"
                name="location"
                value={userData.location}
                disabled
              />
            </Box>

            {/* Image URL Field */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <ImageIcon sx={{ flexShrink: 0, color: "#42326e" }} />
              <TextField
                fullWidth
                label="Company Logo URL"
                variant="outlined"
                name="image_url"
              />
            </Box>

            {/* ID Proof File Upload */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <InsertDriveFileIcon
                sx={{ flexShrink: 0, color: "#42326e" }}
              />
              <TextField
                fullWidth
                label="ID Proof"
                variant="outlined"
                value={idProofFile ? idProofFile.name : ""}
                required
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <Button
                      variant="outlined"
                      component="label"
                      sx={{ borderRadius: 1 }}
                    >
                      Upload
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(e) =>
                          handleFileChange(e, setIdProofFile, setIdProofUrl)
                        }
                      />
                    </Button>
                  ),
                }}
              />
            </Box>

            {/* Image Preview for ID Proof */}
            {idProofUrl && (
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <img
                  alt="ID Proof Preview"
                  src={idProofUrl}
                  style={{
                    maxWidth: "100%",
                    height: "150px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}

            {/* Submit Button */}
            <Button
              variant="contained"
              color="success"
              fullWidth
              sx={{ mt: 3, py: 1 }}
              type="submit"
            >
              Proceed to Payment
            </Button>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Subscription;
